import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { DropdownThreeDotsIcon } from '@hivebrite/design-system/Dropdown';

import DeleteContentModal from 'hb-react/frontoffice/components/DeleteContentModal';
import ReportContent from 'hb-react/frontoffice/components/ReportContent';

import { actionItemsIcons as icons } from './actionItemsIcons';

const JobDropdown = ({
  editUrl,
  jobId,
  jobUserId,
  onDeleteItem,
  currentUser,
  currentNetwork,
  onCompanyPage,
}) => {
  const navigate = useNavigate();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [reportingModalOpen, setReportingModalOpen] = useState(false);
  const dropdownItems = (() => {
    if (currentUser && currentUser.id === jobUserId) {
      const editAction = {
        label: __('Edit'),
        icon: icons.edit,
        onClick: () => navigate(editUrl),
      };

      if (onCompanyPage) {
        return [editAction];
      }

      return [
        editAction,
        {
          label: __('Delete'),
          dataTestId: 'card-job-delete-content',
          icon: icons.delete,
          onClick: () => setDeleteModalOpen(true),
        },
      ];
    }

    if (currentNetwork?.network_config?.user_can_report_user_contents) {
      return [
        {
          dataTestId: 'card-job-report-content',
          icon: icons.circleExclamation,
          label: I18n.t('web.content_reporting.call_to_action_title'),
          onClick: () => setReportingModalOpen(true),
        },
      ];
    }

    return [];
  })();

  if (dropdownItems.length === 0) {
    return null;
  }

  return (
    <Box data-testid="job-card-dropdown" flex="0 0 auto" alignSelf="flex-start">
      <Box ml={1} alignItems="flex-start">
        <DropdownThreeDotsIcon
          title={__('Dropdown')}
          buttonWrapperProps={{ 'aria-label': 'job-card-dropdown' }}
          items={dropdownItems}
          position="left"
        />
      </Box>

      {deleteModalOpen && (
        <DeleteContentModal
          onClickYes={() => {
            onDeleteItem({ id: jobId });
          }}
          onClose={() => setDeleteModalOpen(false)}
        />
      )}
      {reportingModalOpen && (
        <ReportContent
          onCloseModal={() => setReportingModalOpen(false)}
          id={jobId}
          type="BusinessOpportunities::Request"
        />
      )}
    </Box>
  );
};

export default JobDropdown;
